export const LogoMark = ({ className = "h-10 w-10" }) => (
  <img
    src="/baytas-logo-square.jpg"
    alt="Baytaş Tarım logosu"
    className={`rounded-full border border-gold/40 object-cover ${className}`}
  />
);

export const Logo = ({ light = false, className = "" }) => (
  <span className={`inline-flex items-center gap-2.5 ${className}`}>
    <LogoMark className="h-10 w-10 shrink-0" />
    <span className="flex flex-col leading-none">
      <span
        className={`font-display text-xl font-extrabold uppercase tracking-tight ${
          light ? "text-paper" : "text-ink"
        }`}
      >
        Baytaş
      </span>
      <span className="mt-0.5 font-mono text-[9px] font-bold uppercase tracking-[0.42em] text-gold">
        Tarım
      </span>
    </span>
  </span>
);